module.exports = __webpack_public_path__ + "media/images/flags/16/United-States-d4452aadb25552d5e5da425756a9f3be.png";